import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from '@magalu/stereo-ui/atoms';
import ProductCarousel from '@magalu/stereo-ui/organisms/ProductCarousel';
import ProductCard from '@magalu/stereo-ui/organisms/ProductCard';
var AdsBrandProducts = function AdsBrandProducts(_ref) {
  var campaignId = _ref.campaignId,
    products = _ref.products,
    template = _ref.template,
    handleProductView = _ref.handleProductView,
    handleProductClick = _ref.handleProductClick;
  var carouselConfig = {
    auto: false,
    enableHover: false,
    gutter: 0,
    showArrowControls: true,
    showControls: false,
    showPartial: false,
    showPartialNextSlide: true,
    slidesPerView: template === 'creative' ? 1 : 3
  };
  var carouselWidth = template === 'creative' ? 310 : 770;
  var parsedProducts = products.map(function (product, index) {
    return {
      allowEmptyRatting: true,
      campaignId: campaignId,
      category: product == null ? void 0 : product.category,
      id: product == null ? void 0 : product.id,
      image: product == null ? void 0 : product.image,
      path: '/',
      position: index + 1,
      price: product == null ? void 0 : product.price,
      seller: product == null ? void 0 : product.seller,
      subcategory: product == null ? void 0 : product.subcategory,
      title: product == null ? void 0 : product.title,
      url: product == null ? void 0 : product.path
    };
  });
  var showCarousel = template === 'collection' && parsedProducts.length >= 4 || template === 'creative' && parsedProducts.length >= 2;
  return React.createElement(Flex, {
    "data-testid": "brand-products",
    width: "100%",
    justifyContent: "center"
  }, showCarousel ? React.createElement(Flex, {
    width: carouselWidth,
    gap: 1,
    flexDirection: "column"
  }, React.createElement(ProductCarousel, _extends({
    "data-testid": "product-carousel",
    products: parsedProducts,
    displayMode: "sponsoredBrandMedium",
    fullHeight: false,
    onProductView: handleProductView,
    onMouseDown: handleProductClick,
    onClick: function onClick(e) {
      return e.preventDefault();
    },
    showDiscount: false,
    showDiscountOnlyCashInfo: false
  }, carouselConfig)), React.createElement(Text, {
    "data-testid": "text-carousel",
    color: "text.scratched",
    fontWeight: "400",
    fontSize: "12px",
    style: {
      alignSelf: 'flex-end',
      marginRight: '44px'
    }
  }, "Patrocinado")) : React.createElement(Flex, {
    width: "fit-content",
    alignItems: "center",
    flexDirection: "column",
    gap: 1
  }, React.createElement(Flex, {
    gap: 2
  }, parsedProducts.map(function (product) {
    return React.createElement("div", {
      "data-testid": "product-card-list",
      key: product.id,
      style: {
        width: '199px'
      }
    }, React.createElement(ProductCard, _extends({
      "data-testid": "product-card",
      onView: handleProductView,
      onMouseDown: handleProductClick,
      onClick: function onClick(e) {
        return e.preventDefault();
      },
      image: product.image,
      installment: product.installment,
      price: product.price,
      title: product.title,
      url: product.url,
      showDiscount: false,
      showDiscountOnlyCashInfo: false,
      displayMode: "sponsoredBrandMedium"
    }, product)));
  })), React.createElement(Text, {
    "data-testid": "text-product-card",
    color: "text.scratched",
    fontWeight: "400",
    fontSize: "12px",
    style: {
      alignSelf: 'flex-end'
    }
  }, "Patrocinado")));
};
AdsBrandProducts.defaultProps = {
  campaignId: '',
  handleProductClick: function handleProductClick() {},
  handleProductView: function handleProductView() {},
  products: [],
  template: null
};
process.env.NODE_ENV !== "production" ? AdsBrandProducts.propTypes = {
  campaignId: PropTypes.string,
  handleProductClick: PropTypes.func,
  handleProductView: PropTypes.func,
  products: PropTypes.arrayOf(),
  template: PropTypes.string
} : void 0;
AdsBrandProducts.ssr = true;
export default AdsBrandProducts;